import { render, staticRenderFns } from "./RegisterCampaign.vue?vue&type=template&id=5bfd4d44&scoped=true"
import script from "./RegisterCampaign.vue?vue&type=script&lang=js"
export * from "./RegisterCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd4d44",
  null
  
)

export default component.exports